import type { Dict } from '../utils'

import { createContext } from '../utils'

const [CheckboxGroupProvider, useCheckboxGroupContext] = createContext<Dict>({ isOptional: true })

export { CheckboxGroupProvider, useCheckboxGroupContext }
